import { Multimedia } from './Multimedia';

export type { TypeGaleriaProps } from './types';
export default Multimedia;
